module.exports = __webpack_public_path__ + "img/pr-22.5a37e725.png";